module.exports = __webpack_public_path__ + "static/media/1012957.1bfa27c2.jpg";